import React, { Component } from 'react'
import PT from 'prop-types'
import { Link, withRouter } from 'react-router-dom'

class Menu extends Component {
  render() {
    const is89 = this.props.location.pathname.startsWith('/89')

    if (is89) {
      return (
        <ul>
          <li><Link to="/89/o-projekte">O projekte</Link></li>
          <li className="pridaj"><Link to="/89/pridat">Pridaj príbeh</Link></li>
          <li><Link to="/89/premietania">Premietania</Link></li>
          <li><Link to="/89/partneri">Partneri</Link></li>
          <li><Link to="/89/kontakt">Kontakt</Link></li>
        </ul>
      )
    }

    return (
      <ul>
        <li><Link to="/o-projekte">O projekte</Link></li>
        <li className="pridaj"><Link to="/pridat">Pridaj príbeh</Link></li>
        <li><Link to="/premietania">Premietania</Link></li>
        <li><Link to="/partneri">Partneri</Link></li>
        <li><Link to="/kontakt">Kontakt</Link></li>
      </ul>
    )
  }
}

Menu.propTypes = {
  location: PT.shape({
    pathname: PT.string.isRequired,
  }).isRequired,
}

export default withRouter(Menu)



// WEBPACK FOOTER //
// ./src/components/Header/Menu.js